<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat>
          <!-- <v-card-title primary-title class="primary white--text">
            <h3 color="primary">Quick Invoice</h3>
          </v-card-title> -->
          <v-card-text>
            <v-card flat>
              <p
                style="
                  font-size: 11px;
                  font-style: italic;
                  color: green;
                  margin: 0px;
                "
              >
                **<b>Select Customer</b> and press <b>[ Ctrl + f </b> to Switch ] <b>[ Ctrl + i </b> to add New Items ] <b> [Ctrl + p</b> to Save and Print Invoice.] & <b>[Ctrl + s</b> to Save Invoice.]
              </p>
              <v-card-text>
                <v-layout row wrap style="margin-top: -30px">
                  <v-flex xs12 sm2 md2>
                    <v-switch
                    disabled
                      v-model="isBuyer"
                      :label="`${
                        isBuyer ? 'Sale Invoice' : 'Purchase Invoice'
                      }`"
                    ></v-switch>
                  </v-flex>

                  <v-flex xs12 sm3 md3>
                    <v-select
                      v-bind:items="isBuyer ? buyersByBrand : sellersByBrand"
                      v-model="selectedBuyer"
                      :label="
                        isBuyer ? 'Select or add Buyer' : 'Select or add Seller'
                      "
                      disabled
                      autocomplete
                      item-text="name"
                      return-object
                      @keyup.native.enter="addCustomer"
                    >
                    </v-select>
                  </v-flex>

                  <v-spacer />

                  <v-flex xs12 sm2 md2>
                    <v-text-field
                      prefix="#"
                      label="Invoice Number"
                      placeholder="Invoice Number"
                      v-model="invoiceId"
                    ></v-text-field>
                  </v-flex>
                  <v-spacer />

                  <v-flex xs12 sm2 md2>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="datepicker"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="invoiceDate"
                        label="Date"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="invoiceDate"
                        @input="datepicker = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-spacer />

                  <v-flex xs12 sm1 md1>
                    <v-text-field
                      prefix="#"
                      label="Alert (in Days)"
                      v-model="alertDuration"
                    ></v-text-field>
                  </v-flex>

                  <v-spacer />

                  <v-flex
                    xs12
                    sm1
                    md1
                    style="margin-top: 12px; text-decoration: none"
                  >
                    <v-btn icon class="primary white--text" @click="$router.go(-1)">
                      <v-icon
                      >
                        mdi-close
                      </v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <h3
                class="error--text text--darken-4"
                v-if="
                  !(
                    new Date(invoiceDate).getTime() >= finYear.start &&
                    new Date(invoiceDate).getTime() <= finYear.end
                  )
                "
              >
                This invoice is not in current financial year.
              </h3>

              <v-data-table
                :headers="getHeaders"
                :items="items"
                hide-actions
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">{{ props.item.productName }}</td>
                  <!-- <td class="text-xs-left">{{ props.item.HSN_code }}</td>
                  <td>{{ props.item.taxableGST_rate }}</td> -->
                  <td>{{ props.item.rate }}</td>
                  <td>{{ props.item.unit }}</td>
                  <td>{{ props.item.quantity }}</td>
                  <td>{{ props.item.basicPrice }}</td>
                  <td v-if="gstInvoice">{{ props.item.GSTValue }}</td>
                  <td>{{ props.item.tradeDiscount }}</td>
                  <td>{{ props.item.specialCharge }}</td>
                  <td>{{ props.item.totlePrice }}</td>
                  <td v-if="gstInvoice">
                    {{ props.item.CGST_val }} ₹ ({{ props.item.CGST }} %)
                  </td>
                  <td v-if="gstInvoice">
                    {{ props.item.SGST_val }} ₹ ({{ props.item.SGST }} %)
                  </td>
                  <td v-if="gstInvoice">
                    {{ props.item.IGST_val }} ₹ ({{ props.item.IGST }} %)
                  </td>
                  <td class="justify-center layout px-0">
                    <v-btn
                      icon
                      class="mx-0"
                      @click="editItem(props.item, false)"
                    >
                      <v-icon color="teal">edit</v-icon>
                    </v-btn>
                    <v-btn icon class="mx-0" @click="deleteItem(props.item)">
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                  </td>
                </template>
                <template slot="no-data">No Items</template>
              </v-data-table>

              <v-card-actions v-if="selectedBuyer && selectedFirm">
                <!-- <v-btn flat @click="resetForm">Reset</v-btn> -->
                <v-layout row wrap>
                  <v-flex xs4>
                    <v-dialog v-model="dialog" persistent max-width="1200px">
                      <template v-if="businessType == 'Jwellery'">
                        <v-btn 
                          flat
                          slot="activator"
                          class="primary white--text"
                          @click="focusAddProduct()"
                        >
                          <v-icon left dark>add</v-icon>
                          New Item
                        </v-btn>
                        <add-item-jewl
                          :editedItem="editedItem"
                          :buyer="selectedBuyer  || null"
                          :allItems="items"
                          :isEditItems="isEditItems"
                          :gstInvoice="gstInvoice"
                          :selectedFirm="selectedFirm"
                          :isBuyer="isBuyer"
                          :isRoundOff="firmSetting && firmSetting.roundOff"
                          @closeAddItem="close"
                          @saveAddItem="save"
                          @editItem="editItem"
                          @deleteItem="deleteItem"
                          @addProduct="addProduct"
                        />
                      </template>

                      <template v-else-if="businessType == 'Grain'">
                        <v-btn 
                          flat
                          slot="activator"
                          class="primary white--text"
                          @click="focusAddProduct()"
                        >
                          <v-icon left dark>add</v-icon>
                          New Item
                        </v-btn>
                        <add-item-grain
                          :editedItem="editedItem"
                          :buyer="selectedBuyer  || null"
                          :allItems="items"
                          :isEditItems="isEditItems"
                          :gstInvoice="gstInvoice"
                          :selectedFirm="selectedFirm"
                          :isBuyer="isBuyer"
                          :isRoundOff="firmSetting && firmSetting.roundOff"
                          @closeAddItem="close"
                          @saveAddItem="save"
                          @editItem="editItem"
                          @deleteItem="deleteItem"
                          @addProduct="addProduct"
                        />
                      </template>

                      <template v-else-if="businessType == 'Clothes'">
                        <v-btn
                          flat
                          slot="activator"
                          class="primary white--text"
                        >
                          <v-icon left dark>add</v-icon>
                          New Item
                        </v-btn>
                        <add-item-clothes
                          :editedItem="editedItem"
                          :buyer="selectedBuyer  || null"
                          :allItems="items"
                          :isEditItems="isEditItems"
                          :gstInvoice="gstInvoice"
                          :selectedFirm="selectedFirm"
                          :isBuyer="isBuyer"
                          :isRoundOff="firmSetting && firmSetting.roundOff"
                          @closeAddItem="close"
                          @saveAddItem="save"
                          @editItem="editItem"
                          @deleteItem="deleteItem"
                          @addProduct="addProduct"
                        />
                      </template>

                      <template v-else-if="businessType == 'Dairy'">
                        <v-btn
                          style="margin-top: 10px"
                          flat
                          slot="activator"
                          class="primary white--text"
                          @click="focusAddProduct()"
                        >
                          <v-icon left dark>add</v-icon>
                          New Item
                        </v-btn>
                        <add-item-dairy
                          :editedItem="editedItem"
                          :buyer="selectedBuyer  || null"
                          :allItems="items"
                          :isEditItems="isEditItems"
                          :gstInvoice="gstInvoice"
                          :selectedFirm="selectedFirm"
                          :isBuyer="isBuyer"
                          :firmSetting="firmSetting" 
                          :invoiceDate="invoiceDate"
                          @closeAddItem="close"
                          @saveAddItem="save"
                          @editItem="editItem"
                          @deleteItem="deleteItem"
                          @addProduct="addProduct"
                          :godawn="godawnBy"
                        />
                      </template>

                      <template v-else-if="businessType == 'Default'">
                        <v-btn 
                          style="margin-top: 10px;"
                          flat 
                          slot="activator" 
                          @click="focusAddProduct()" 
                          class="primary white--text">
                            <v-icon left dark>add</v-icon>
                          New Item
                        </v-btn>
                        <add-item-default
                          :editedItem="editedItem"
                          :buyer="selectedBuyer  || null"
                          :allItems="items"
                          :isEditItems="isEditItems"
                          :gstInvoice="gstInvoice"
                          :selectedFirm="selectedFirm"
                          :isBuyer="isBuyer"
                          :isRoundOff="firmSetting && firmSetting.roundOff"
                          @closeAddItem="close"
                          @saveAddItem="save"
                          @editItem="editItem"
                          @deleteItem="deleteItem"
                          @addProduct="addProduct"
                        />
                      </template>

                      <template
                        v-else-if="businessType == 'Automobile/Agriculture/Spare Parts'"
                      >
                        <v-btn
                          flat
                          slot="activator"
                          class="primary white--text"
                        >
                          <v-icon left dark>add</v-icon>
                          New Item
                        </v-btn>
                        <add-item-auto
                          :editedItem="editedItem"
                          :buyer="selectedBuyer  || null"
                          :allItems="items"
                          :isEditItems="isEditItems"
                          :gstInvoice="gstInvoice"
                          :selectedFirm="selectedFirm"
                          :isBuyer="isBuyer"
                          :isRoundOff="firmSetting && firmSetting.roundOff"
                          @closeAddItem="close"
                          @saveAddItem="save"
                          @editItem="editItem"
                          @deleteItem="deleteItem"
                          @addProduct="addProduct"
                        />
                      </template>
                      <template v-else>
                        <v-btn
                          flat
                          slot="activator"
                          class="primary white--text"
                        >
                          <v-icon left dark>add</v-icon>
                          New Item
                        </v-btn>
                        <add-item-med
                          :editedItem="editedItem"
                          :buyer="selectedBuyer  || null"
                          :dialog="dialog"
                          :allItems="items"
                          :isEditItems="isEditItems"
                          :gstInvoice="gstInvoice"
                          :selectedFirm="selectedFirm"
                          :isBuyer="isBuyer"
                          :isRoundOff="firmSetting && firmSetting.roundOff"
                          @closeAddItem="close"
                          @saveAddItem="save"
                          @editItem="editItem"
                          @deleteItem="deleteItem"
                          @addProduct="addProduct"
                        />
                      </template>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs3>
                     <v-btn
                        style="margin-top: 10px;"
                        flat
                        class="warning white--text"
                        @click="billingDetailsDialog = true"
                      ><v-icon left dark>
                        add
                      </v-icon>
                        Mailing Info
                      </v-btn>
                   </v-flex>
                  <v-flex xs3>
                    <v-select
                      v-model="selectedProductSet"
                      :label="'Select Product Set'"
                      item-text="name"
                      clearable
                      :items="ProductSetByBrand"
                      return-object
                      @change="selectProductSet"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-spacer></v-spacer>
                <v-card-actions
                  v-if="selectedFirm && transactionType && items.length"
                >
                 <!-- <v-btn
                   flat
                   @click.native="eWayBillPrint()"
                   class="info white--text"
                   >E-Way Bill
                </v-btn> -->
                 <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        flat
                        class="warning white--text"
                        v-on="on"
                      >
                        Print Preview
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile
                        @click="printInvoice4(false)"
                      >
                        <v-list-tile-title >Simple Print</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        @click="basicInvoicePrint(true)"
                      >
                        <v-list-tile-title >Basic Print</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        @click="basicInvoicePrint(false)"
                      >
                        <v-list-tile-title>Detailed Print</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                  <v-spacer/>
                  <!-- <v-btn
                    flat
                    class="warning white--text"
                    @click="basicInvoicePrint()"
                    >Print</v-btn
                  > -->
                  <!-- <v-btn
                    flat
                    @click.native="saveAndPrint()"
                    class="info white--text"
                    >Save & Print</v-btn
                  > -->
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        flat
                        class="primary white--text"
                        v-on="on"
                      >
                        Save & Print
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile
                        @click="printInvoice4(true)"
                      >
                        <v-list-tile-title >Simple Print</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        @click="saveAndPrint(true)"
                      >
                        <v-list-tile-title >Basic Print</v-list-tile-title>
                      </v-list-tile>
                       <v-list-tile
                        @click="saveAndPrint(false)"
                      >
                        <v-list-tile-title>Detail Print</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                  <v-spacer/>
                  <v-btn
                    flat
                    @click.native="saveInvoice()"
                    class="success white--text"
                    >Save Invoice</v-btn
                  >
                </v-card-actions>
              </v-card-actions>

              <v-dialog
                v-model="transactionDialog"
                persistent
                max-width="500px"
              >
                <v-card>
                  <v-card-title class="primary white--text">
                    <span class="headline">
                      Payment Details: 
                    </span>
                    <v-spacer/>
                    <v-btn icon dark @click.native="transactionDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field
                            type="number"
                            label="Total Amount (in ₹)"
                            readonly
                            :value="totalAmount"
                            prefix
                          ></v-text-field>
                          <v-select
                            dense
                            :items="[
                              {
                                text: 'Cash',
                                value: 'Cash',
                              },
                              {
                                text: 'Bank Account',
                                value: 'Bank Account',
                              },
                              {
                                text: 'Cash & Bank Account',
                                value: 'CashAndBank Account',
                              },
                            ]"
                            label="Select Payment Type"
                            @change="resetAmounts()"
                            v-model="paymentType"
                          ></v-select>

                          <v-select
                            dense
                            :items="banksByFirms"
                            v-if="
                              ['Bank Account', 'CashAndBank Account'].includes(
                                paymentType
                              )
                            "
                            label="Select Bank"
                            v-model="selectedBank"
                            :disabled="
                              paymentType == 'Cash' || paymentType == ''
                            "
                          ></v-select>

                          <v-select
                            dense
                            :disabled="
                              paymentType == 'Cash' || paymentType == ''
                            "
                            v-if="
                              ['Bank Account', 'CashAndBank Account'].includes(
                                paymentType
                              )
                            "
                            :items="[
                              {
                                text: 'Cheque',
                                value: 'Cheque',
                              },
                              {
                                text: 'NEFT',
                                value: 'NEFT',
                              },
                              {
                                text: 'RTGS',
                                value: 'RTGS',
                              },
                              {
                                text: 'IMPS',
                                value: 'IMPS',
                              },
                            ]"
                            label="Select Transfer type"
                            v-model="transferType"
                            @input="transferTypeDialog = true"
                          ></v-select>

                          <v-text-field
                            v-if="!['Bank Account'].includes(paymentType)"
                            v-model="amountFromCash"
                            type="number"
                            :disabled="amountFromCashDisabled"
                            label="Amount from Cash"
                          ></v-text-field>

                          <v-text-field
                            v-if="
                              ['Bank Account', 'CashAndBank Account'].includes(
                                paymentType
                              )
                            "
                            v-model="amountFromBank"
                            type="number"
                            :disabled="amountFromBankDisabled"
                            label="Amount from Bank"
                          ></v-text-field>

                          <v-text-field
                            v-if="remainingAmount > 0"
                            type="number"
                            label="Remaining Amount (in ₹)"
                            readonly
                            v-model="remainingAmount"
                            prefix
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      :disabled="!paymentType"
                      flat
                      @click.native="transactionDialog = false"
                      >Confirm</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="transferTypeDialog" max-width="500px">
                <v-card>
                  <v-card-title class="primary white--text">
                    <span class="headline">
                      Transfer Information
                      <b>{{ transferType }}</b>
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md6>
                          <v-text-field
                            type="number"
                            v-model="transferDetails.accountNumber"
                            label="A/C Number"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-text-field
                            type="text"
                            v-model="transferDetails.accountHolderName"
                            label="A/C Holder Name"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-text-field
                            type="text"
                            v-model="transferDetails.bankName"
                            label="Bank Name"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-text-field
                            type="text"
                            v-model="transferDetails.IFSCcode"
                            label="IFSC Code"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-text-field
                            type="text"
                            v-model="transferDetails.remark"
                            label="Remark"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      flat
                      @click.native="transferTypeDialog = false"
                      >Ok</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-card-text>
                <v-layout dense flat row wrap>
                  <v-flex xs12 s12 md8>
                    <v-expansion-panel class="invoiceExpansion">
                      <v-expansion-panel-content :value="expansionVal">
                        <template v-slot:header>
                          <v-card-title>
                            <h3
                              class="title font-weight-light primary white--text"
                            >
                              Basic Details
                            </h3>
                          </v-card-title>
                        </template>
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs4>
                                <v-text-field
                                  label="Total Item"
                                  readonly
                                  :value="totalItems"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs4>
                                <v-select
                                  dense
                                  :items="firmsByBrand"
                                  label="Select Firm"
                                  v-model="selectedFirm"
                                ></v-select>
                              </v-flex>
                              <v-flex xs4>
                                <v-select
                                  dense
                                  :disabled="!items.length"
                                  :items="[
                                    {
                                      text: 'Due',
                                      value: 'Debit',
                                    },
                                    {
                                      text: 'Partial Paid',
                                      value: 'Partial Paid',
                                    },
                                    {
                                      text: 'Full Paid',
                                      value: 'Credit',
                                    },
                                  ]"
                                  label="Select Transaction type"
                                  @change="resetAmounts()"
                                  v-model="transactionType"
                                ></v-select>
                              </v-flex>

                              <v-flex xs4>
                                <v-text-field
                                  type="number"
                                  label="Discount (in ₹)"
                                  v-model="discountAmount"
                                >
                                </v-text-field>
                              </v-flex>

                              <v-flex xs4>
                                <v-text-field
                                  type="number"
                                  label="Round Off (in ₹)"
                                  v-model="roundOffAmount"
                                >
                                </v-text-field>
                              </v-flex>

                              <v-flex xs4>
                                <v-select
                                  dense
                                  :items="staffByBrand"
                                  label="Sold By"
                                  v-model="soldBy"
                                ></v-select>
                              </v-flex>

                              <v-flex xs4>
                                <v-text-field
                                  type="Number"
                                  label="Brokerage Rate (in %)"
                                  v-model="brokerageRate"
                                >
                                </v-text-field>
                              </v-flex>

                              <v-flex xs4>
                                <v-text-field
                                  type="number"
                                  label="Brokerage Amount (in ₹)"
                                  disabled
                                  :value="
                                    Number.parseFloat(
                                      (Number.parseFloat(totalAmount) *
                                        brokerageRate) /
                                        100
                                    ).toFixed(2)
                                  "
                                >
                                </v-text-field>
                              </v-flex>

                              <!-- <v-flex xs4>
                      <v-select
                        dense
                        :items="godawnByBrand"
                        label="Via Godawn"
                        v-model="godawnBy"
                      ></v-select>
                    </v-flex> -->

                              <v-flex xs4>
                                <v-select
                                  dense
                                  :items="gState"
                                  label="Place of Supply"
                                  item-text="state"
                                  v-model="placeOfSupply"
                                ></v-select>
                              </v-flex>

                              <v-flex xs6>
                                <v-textarea 
                                  background-color="grey darken-1" 
                                  color="black"
                                  box label="Delivery Terms" 
                                  v-model="remark">
                                </v-textarea>
                              </v-flex>
                              <v-flex xs12 sm2 md2>
                                <v-switch
                                  v-model="isIncentive"
                                  :label="`Incentive`"
                                  @change="changeIncentive()"
                                ></v-switch>
                                <p
                                  style="
                                    font-size: 11px;
                                    font-style: italic;
                                    color: green;
                                    margin: 0px;
                                  "
                                  v-if="isIncentive"
                                >
                                  **Press enter to add more incentive.
                                </p>
                                 <template v-for="inc in incentives" >
                                  <v-text-field
                                    v-if="isIncentive"
                                    type="number"
                                    v-model="inc.percentage"
                                    :key="inc.order+'per'"
                                    prefix="%"
                                    :label="'Incentive ' +inc.order+'.'"
                                    @keydown="addIncentive($event,inc)"
                                  ></v-text-field>
                                </template>
                              </v-flex>
                              <v-flex xs12 sm2 md4>
                                  <v-autocomplete
                                      :items="extraChargesSample"
                                      v-model="extraCharges"
                                      label="Extra Charges"
                                      item-text="name"
                                      :return-object="true"
                                      @keyup.native.enter="addCharges"
                                      multiple
                                    ></v-autocomplete>
                                  <br/>
                                  <v-layout wrap>
                                    <template v-for="(ext, index) in extraCharges">
                                    <v-flex :key="'name'+index" xs6>
                                        <v-text-field type="text" v-model="ext.name" label="Charge Name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex :key="'amount'+index" xs6>
                                        <v-text-field :key="'amt'+index" type="number" v-model="ext.amount" label="Amount">
                                        </v-text-field>
                                    </v-flex>
                                    </template>
                                  </v-layout>
                              </v-flex> 
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-flex>
                  <v-flex xs12 s12 md4>
                    <v-expansion-panel class="invoiceExpansion">
                      <v-expansion-panel-content :value="expansionVal">
                        <template v-slot:header>
                          <div>
                            <v-card-title>
                              <h3
                                class="title font-weight-light primary white--text"
                              >
                                Invoice Details
                              </h3>
                            </v-card-title>
                          </div>
                        </template>
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md6 style="margin-top: 1px">
                                <h3 class="primary--text">Taxable Amount</h3>
                              </v-flex>
                              <v-flex xs12 sm6 md6 style="display: inline-flex">
                                <v-text-field
                                  style="margin-top: -20px"
                                  readonly
                                  :value="
                                    (
                                      Number.parseFloat(totalAmount) +
                                      Number.parseFloat(discountAmount) -
                                      Number.parseFloat(totalExtraCharges) -
                                      Number.parseFloat(roundOffAmount) -
                                      (Number.parseFloat(
                                        GST_Val_total.SGST_val
                                      ) +
                                        Number.parseFloat(
                                          GST_Val_total.CGST_val
                                        ) +
                                        Number.parseFloat(
                                          GST_Val_total.IGST_val
                                        ))
                                    ).toFixed(2)
                                  "
                                  type="number"
                                ></v-text-field>
                              </v-flex>
                              <v-flex
                                xs12
                                sm6
                                md6
                                style="margin-top: -5px"
                                v-if="gstInvoice"
                              >
                                <h3 class="primary--text">CGST Amount</h3>
                              </v-flex>
                              <v-flex
                                xs12
                                s6
                                md6
                                style="display: inline-flex"
                                v-if="gstInvoice"
                              >
                                <v-text-field
                                  style="margin-top: -20px"
                                  readonly
                                  :value="GST_Val_total.CGST_val.toFixed(2)"
                                  type="number"
                                ></v-text-field>
                              </v-flex>
                              <v-flex
                                xs12
                                sm6
                                md6
                                style="margin-top: -5px"
                                v-if="gstInvoice"
                              >
                                <h3 class="primary--text">SGST Amount</h3>
                              </v-flex>
                              <v-flex
                                xs12
                                s6
                                md6
                                style="display: inline-flex"
                                v-if="gstInvoice"
                              >
                                <v-text-field
                                  style="margin-top: -20px"
                                  readonly
                                  :value="GST_Val_total.SGST_val.toFixed(2)"
                                  type="number"
                                ></v-text-field>
                              </v-flex>
                              <v-flex
                                xs12
                                sm6
                                md6
                                style="margin-top: -5px"
                                v-if="gstInvoice"
                              >
                                <h3 class="primary--text">IGST Amount</h3>
                              </v-flex>
                              <v-flex
                                xs12
                                s6
                                md6
                                style="display: inline-flex"
                                v-if="gstInvoice"
                              >
                                <v-text-field
                                  style="margin-top: -20px"
                                  readonly
                                  :value="GST_Val_total.IGST_val.toFixed(2)"
                                  type="number"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md6 style="margin-top: -5px">
                                <h3 class="primary--text">Discount</h3>
                              </v-flex>
                              <v-flex xs12 s6 md6 style="display: inline-flex">
                                <v-text-field
                                  readonly
                                  style="margin-top: -20px"
                                  type="number"
                                  v-model="discountAmount"
                                >
                                </v-text-field>
                              </v-flex>
                              <template v-for="(ext, index) in extraCharges">
                                        <v-flex :key="'extraname'+index" xs12 sm6 md6 style="margin-top: -5px">
                                          <h3 class="primary--text">{{ext.name}}</h3>
                                        </v-flex>
                                        <v-flex  :key="'extraamount'+index" xs12 s6 md6 style="display: inline-flex">
                                          <v-text-field
                                            readonly
                                            style="margin-top: -20px"
                                            type="number"
                                            v-model="ext.amount"
                                            >
                                        </v-text-field>
                                    </v-flex>
                                    </template>
                              <v-flex xs12 sm6 md6 style="margin-top: -5px">
                                <h3 class="primary--text">Round Off</h3>
                              </v-flex>
                              <v-flex xs12 s6 md6 style="display: inline-flex">
                                <v-text-field
                                  readonly
                                  style="margin-top: -20px"
                                  type="number"
                                  v-model="roundOffAmount"
                                >
                                </v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md6 style="margin-top: -5px">
                                <h3 class="primary--text">Invoice Amount</h3>
                              </v-flex>
                              <v-flex xs12 s6 md6 style="display: inline-flex">
                                <v-text-field
                                  style="margin-top: -20px"
                                  type="number"
                                  readonly
                                  :value="
                                    (
                                      Number.parseFloat(totalAmount)
                                    ).toFixed(2)
                                  "
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12 s12 md12>
                    <v-expansion-panel class="invoiceExpansion">
                      <v-expansion-panel-content>
                        <template v-slot:header>
                            <v-card-title>
                              <h3 class="title font-weight-light primary white--text">
                                Extra Details
                              </h3>
                            </v-card-title>
                        </template>
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12 s12 md4>
                            <v-text-field
                               type="text"
                               label="Order Number"
                               v-model="orderNumber"
                               prefix
                             ></v-text-field>
                             <br/>
                             <v-menu
                               :close-on-content-click="false"
                               v-model="orderDatepicker"
                               :nudge-right="40"
                               lazy
                               transition="scale-transition"
                               offset-y
                               full-width
                               min-width="290px"
                             >
                               <v-text-field
                                 slot="activator"
                                 v-model="orderDate"
                                 label="Order Date"
                                 readonly
                               ></v-text-field>
                               <v-date-picker
                                 v-model="orderDate"
                                 @input="orderDatepicker = false"
                               ></v-date-picker>
                             </v-menu>
                             <br/>
                             <v-menu
                               :close-on-content-click="false"
                               v-model="sanctionDatepicker"
                               :nudge-right="40"
                               lazy
                               transition="scale-transition"
                               offset-y
                               full-width
                               min-width="290px"
                             >
                               <v-text-field
                                 slot="activator"
                                 v-model="sanctionDate"
                                 label="Sanction Date"
                                 readonly
                              ></v-text-field>
                               <v-date-picker
                                 v-model="sanctionDate"
                                 @input="sanctionDatepicker = false"
                               ></v-date-picker>
                              </v-menu>
                              <br />
                              <v-text-field
                               type="text"
                               label="Application Number"
                               v-model="applicationNumber"
                               prefix
                             ></v-text-field>
                            <br />
                            <v-btn
                              class="primary--text font-weight-bold"
                              outline
                              flat
                              @click.native="transactionDialog = true"
                              >View Transaction Summary
                            </v-btn>
                          </v-flex>
                              <v-flex xs12 sm4 md4>
                                <v-text-field
                                  readonly
                                  :value="GST_Percentage_total.GST_3"
                                  type="number"
                                  v-if="gstInvoice"
                                  label="Total GST(3%)"
                                ></v-text-field>
                                <br />
                                <v-text-field
                                  readonly
                                  v-if="gstInvoice"
                                  :value="GST_Percentage_total.GST_5"
                                  type="number"
                                  label="Total GST(5%)"
                                ></v-text-field>
                                <br />
                                <v-text-field
                                  readonly
                                  v-if="gstInvoice"
                                  :value="GST_Percentage_total.GST_12"
                                  type="number"
                                  label="Total GST(12%)"
                                ></v-text-field>
                                <br />
                                <v-text-field
                                  readonly
                                  v-if="gstInvoice"
                                  :value="GST_Percentage_total.GST_18"
                                  type="number"
                                  label="Total GST(18%)"
                                ></v-text-field>
                                <br />
                                <v-text-field
                                  v-if="gstInvoice"
                                  readonly
                                  :value="GST_Percentage_total.GST_28"
                                  type="number"
                                  label="Total GST(28%)"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm4 md4>
                                <v-select
                                  dense
                                  readonly
                                  :items="[
                                    {
                                      text: 'Cash',
                                      value: 'Cash',
                                    },
                                    {
                                      text: 'Bank Account',
                                      value: 'Bank Account',
                                    },
                                    {
                                      text: 'Cash & Bank Account',
                                      value: 'CashAndBank Account',
                                    },
                                  ]"
                                  label="Select Payment Type"
                                  @change="resetAmounts()"
                                  v-model="paymentType"
                                ></v-select>
                                <br />

                                <v-text-field
                                  readonly
                                  v-model="amountFromCash"
                                  type="number"
                                  :disabled="amountFromCashDisabled"
                                  label="Amount from Cash"
                                ></v-text-field>
                                <br />
                                <v-text-field
                                  readonly
                                  v-model="amountFromBank"
                                  type="number"
                                  :disabled="amountFromBankDisabled"
                                  label="Amount from Bank"
                                ></v-text-field>
                                <br />

                                <v-text-field
                                  type="number"
                                  label="Paid Amount (in ₹)"
                                  readonly
                                  v-model="paidAmount"
                                  prefix
                                ></v-text-field>
                                <br />
                                <v-text-field
                                  type="number"
                                  label="Remaining Amount (in ₹)"
                                  readonly
                                  v-model="remainingAmount"
                                  prefix
                                ></v-text-field>
                                <br />
                                <v-select
                                  readonly
                                  dense
                                  :items="[
                                    {
                                      text: 'Due',
                                      value: 'Debit',
                                    },
                                    {
                                      text: 'Partial Paid',
                                      value: 'Partial Paid',
                                    },
                                    {
                                      text: 'Full Paid',
                                      value: 'Credit',
                                    },
                                  ]"
                                  label="Select Transaction type"
                                  @change="resetAmounts()"
                                  v-model="transactionType"
                                ></v-select>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-flex>
                </v-layout>

                <v-layout row wrap v-if="this.firmSetting && this.firmSetting.ewayBill">
                <v-flex xs12 s12 md12>
                  <v-expansion-panel class="invoiceExpansion">
                    <v-expansion-panel-content>
                      <template v-slot:header>
                          <v-card-title>
                            <h3 class="title font-weight-light primary white--text">
                              Transport Details
                            </h3>
                          </v-card-title>
                      </template>
                      <v-card>
                        <v-card-text>
                           <eway-bill
                            :invoiceData="invoiceDraft"
                            :bank="bankById[selectedBank]"
                            :firm="firmById[selectedFirm]"
                            :selectedBuyer="selectedBuyer"
                            :isBuyer="isBuyer"
                            :ewayBillDetails="invoiceDraft.ewayBillDetails"
                            :termsAndConditions="getTermsAndConditions()"
                            :gstTotal="GST_Val_total"
                            @ewayBillSave="ewayBillSave"
                          />
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-flex>
              </v-layout>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-snackbar v-model="snackbarSuccess" top color="success" :timeout="3000">
        Invoice updated successfully!
      </v-snackbar>
    </v-layout>
    <!-- <v-dialog
     v-model="ewayBillDialog"
     fullscreen
     hide-overlay
     transition="dialog-bottom-transition"
     scrollable
     persistent
   >
     <v-card v-if="ewayBillDialog" tile style="height: fit-content;">
       <v-toolbar card dark color="primary">
         <v-toolbar-title>Print an E-Way Bill</v-toolbar-title>
         <v-spacer/>
         <v-btn icon dark @click.native="ewayBillDialog = false">
           <v-icon>close</v-icon>
         </v-btn>
       </v-toolbar>
       <eway-bill
         :invoiceData="invoiceDraft"
         :bank="bankById[selectedBank]"
         :firm="firmById[selectedFirm]"
         :selectedBuyer="selectedBuyer"
         :isBuyer="isBuyer"
         :ewayBillDetails="invoiceDraft.ewayBillDetails"
         :termsAndConditions="getTermsAndConditions()"
         :gstTotal="GST_Val_total"
         @ewayBillSave="ewayBillSave"
       />
       <div style="flex: 1 1 auto;"></div>
     </v-card>
   </v-dialog> -->
    <v-dialog v-model="otpData.dialog" persistent max-width="400">
       <v-card>
         <v-card-title  primary title class="primary white--text">
            <span class="headline">Please enter OTP that has been sent to mobile {{otpData.mobile}} to create invoice.</span> 
         </v-card-title>
         <v-card-text>
           <v-layout row>
             <v-flex xs12>
               <v-text-field
                 type="number"
                 label="OTP"
                 v-model="otpData.confirmOtp"
               ></v-text-field>
             </v-flex>
           </v-layout>
         </v-card-text>
         <v-card-actions>
         <v-spacer></v-spacer>
           <v-btn primary title class="primary white--text" flat="flat" @click="confirmOTP">
             Confirm
           </v-btn>
         </v-card-actions>
       </v-card>
    </v-dialog>
    <v-dialog v-model="addProductDialog" fullscreen hide-overlay>
      <add-product
      :currentProduct="currentProduct"
      :stepperValue="stepperValue"
      @saveProduct="saveProduct()"
      @close="addProductDialog = false"
      />
    </v-dialog>
    <v-dialog
        v-model="billingDetailsDialog"
        persistent
        max-width="500px"
      >
        <v-card>
          <v-card-title class="primary white--text">
            <span class="headline"
              >Billing Details
            </span>
            <v-spacer/>
            <v-btn icon dark @click.native="billingDetailsDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Billing Name"
                    v-model="billingDetails.name"
                  ></v-text-field>
                    <v-text-field
                    label="Mobile"
                    v-model="billingDetails.mobile"
                  ></v-text-field>
                  <v-textarea
                    box
                    label="Address"
                    v-model="billingDetails.address"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click.native="saveBillingData()"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="snackbar"
      >
      {{snackbarMsg}}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <iframe id="printPdf" name="printPdf"></iframe>
  </v-container>
</template>
            

<script>
import { createNamespacedHelpers } from "vuex";
import AddItemMed from "./AddItemMed";
import AddItemAuto from "./AddItemAuto";
import AddItemDefault from "./AddItemDefault";
import AddItemClothes from "./AddItemClothes";
import AddItemJewl from "./AddItemJewl";
import AddItemDairy from "./AddItemDairy";
import AddItemGrain from "./AddItemGrain";
import EwayBill from "./ewayBill";

import {
  convertToBasicInvoice,
  convertToBasicInvoiceWithoutGST,
  convertToBasicInvoiceHorizontal,
  convertToSimpleInvoicePrint
} from "../../../utils/pdfmake";
import {sendSms,sendWhatsApp} from "../../../services/twilio.js"
import { getGSTPercentageTotal } from "../../../utils/";
import AddProduct from "../../Products/addProduct";

const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];

export default {
  components: {
    AddProduct,
    AddItemMed,
    AddItemDefault,
    AddItemAuto,
    AddItemClothes,
    AddItemJewl,
    AddItemDairy,
    AddItemGrain,
    EwayBill
  },
  data() {
    return {
      addProductDialog : false,
      stepperValue : null,
      invoiceDraftPrevious : null,
      currentProduct: {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        brand: "",
        openingDate : new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue : 0,
        basicPrice : 0,
        barcode:"",
        productGroup:null,
        productCategory:null,
        productType:null,
        unitsDetails : [
          {
            unit:'',
            isLast: true,
            isFirst:true,
            order : 1,
            quantity : 0,
            rate: true
          }
        ],
        unitsDeatilsAdded : false,
      },
      selectedProductSet: null,
      otpData : {
         otp : null,
         mobile : null,
         dialog : false,
         confirmOtp : null,
      },
      isPaymentDone : null,
      dialog: false,
      isIncentive:false,
      //ewayBillDialog: false,
      billingDetailsDialog: false,
      incentives:[],
      extraCharges:[],
      extraChargesSample:[
        {
          name:'Freight Charge',
          amount:0
        },
        {
          name:'Labour Charge',
          amount:0
        },
        {
          name:'Making Charge',
          amount:0
        },
        {
          name:'Other Charge',
          amount:0
        },
        {
          name:'Service Charge',
          amount:0
        },
        {
          name:'TCS',
          amount:0
        },
      ],
      totalExtraCharges : 0,
      businessType: null,
      selectedBuyer: null,
      isBuyer: true,
      snackbarSuccess: false,
      isEditItems: false,
      gstInvoice: false,
      duplicateError: null,
      selectedFirmState: null,
      items: [],
      totalTradeDiscount: 0,
      totalSpecialCharge: 0,
      editedIndex: -1,
      editedItem: {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 1,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        tradeDiscount: 0,
        specialCharge: 0,
        expiryDate: new Date(
          new Date().setFullYear(new Date().getFullYear() + 100)
        )
          .toISOString()
          .substr(0, 10),
        manufacturingDate: new Date(
          new Date().setFullYear(new Date().getFullYear() + 100)
        )
          .toISOString()
          .substr(0, 10),
        batchNumber: "DEFAULT",
      },
      defaultItem: {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 1,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        tradeDiscount: 0,
        specialCharge: 0,
        expiryDate: new Date(
          new Date().setFullYear(new Date().getFullYear() + 100)
        )
          .toISOString()
          .substr(0, 10),
        manufacturingDate: new Date(
          new Date().setFullYear(new Date().getFullYear() + 100)
        )
          .toISOString()
          .substr(0, 10),
        batchNumber: "DEFAULT",
      },
      amountFromCash: 0,
      amountFromBank: 0,
      alertDuration: 0,
      paymentType: "",
      selectedFirm: "",
      selectedBank: "",
      soldBy: "",
      brokerageRate: 0,
      // godawnBy : '',
      placeOfSupply: "",
      invoiceDate: new Date().toISOString().substr(0, 10),
      dateFormatted: new Date().toISOString().substr(0, 10),
      datepicker: false,
      totalAmount: 0,
      paidAmount: 0,
      remainingAmount: 0,
      discountAmount: 0,
      roundOffAmount: 0,
      invoiceDraft: {},
      transferType: null,
      transferTypeDialog: false,
      availableBalance: 0,
      firms: [],
      staffs: [],
      // godawns: [],
      banks: [],
      transactionType: "Debit",
      amountFromCashDisabled: true,
      amountFromBankDisabled: true,
      status: null,
      gstType: null,
      remark: null,
      invoiceId: null,
      snackbar : null,
      snackbarMsg : null,
      GST_Val_total: {
        CGST_val: 0,
        SGST_val: 0,
        IGST_val: 0,
      },
      GST_Percentage_total: {
        GST_0: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0,
      },
      roundOff: 2,
      transactionDialog: false,
      expansionVal: false,
      transferDetails: {
        accountNumber: null,
        accountHolderName: null,
        bankName: null,
        IFSCcode: null,
        remark: null,
      },
      orderNumber : null,
      applicationNumber : null,
      sanctionDatepicker : null,
      sanctionDate : null,
      orderDatepicker : null,
      orderDate : null,
      billingDetails : {
        name : null,
        mobile : null,
        address : null
      }
    };
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear", "adminEmail","brandFinYear"]),
    ...mapGlobalGetters({
      gState: "state",
    }),
    firmSetting(){
      if(this.selectedFirm) {
        return this.firmSettings.filter(item => item['firm'] == this.selectedFirm)[0];
      }
    },
    getHeaders() {
      if (this.gstInvoice) {
        return [
          {
            text: "Name",
            sortable: false,
            value: "productName",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Rate",
            sortable: false,
            value: "rate",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Unit",
            sortable: false,
            value: "unit",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Quantity",
            sortable: false,
            value: "quantity",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Basic Price",
            sortable: false,
            value: "basicPrice",
            class: "font-weight-bold primary--text",
          },
          {
            text: "GST value",
            sortable: false,
            value: "GSTValue",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Trade Discount",
            sortable: false,
            value: "totlePrice",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Special Charge",
            sortable: false,
            value: "specialCharge",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Total Price",
            sortable: false,
            value: "totlePrice",
            class: "font-weight-bold primary--text",
          },
          {
            text: "CGST ",
            sortable: false,
            value: "CGST",
            class: "font-weight-bold primary--text",
          },
          {
            text: "SGST ",
            sortable: false,
            value: "SGST",
            class: "font-weight-bold primary--text",
          },
          {
            text: "IGST ",
            sortable: false,
            value: "IGST",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Action ",
            sortable: false,
            value: "action",
            class: "font-weight-bold primary--text",
          },
          { text: "", value: "name", sortable: false },
        ];
      } else {
        return [
          {
            text: "Name",
            sortable: false,
            value: "productName",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Rate",
            sortable: false,
            value: "rate",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Unit",
            sortable: false,
            value: "unit",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Quantity",
            sortable: false,
            value: "quantity",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Basic Price",
            sortable: false,
            value: "basicPrice",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Trade Discount",
            sortable: false,
            value: "totlePrice",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Special Charge",
            sortable: false,
            value: "specialCharge",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Total Price",
            sortable: false,
            value: "totlePrice",
            class: "font-weight-bold primary--text",
          },
          {
            text: "Action ",
            sortable: false,
            value: "action",
            class: "font-weight-bold primary--text",
          },
          { text: "", value: "name", sortable: false },
        ];
      }
    },

    buyersByBrand() {
      return this.buyers.filter((item) => {
        return item["brand"] === this.selectedBrand;
      });
    },
    sellersByBrand() {
      return this.sellers.filter((item) => {
        return item["brand"] === this.selectedBrand;
      });
    },
    ProductSetByBrand() {
      return this.productSets.filter((item) => {
        return item["brand"] === this.selectedBrand;
      });
    },
    firmsByBrand() {
      return this.firms
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    staffByBrand() {
      return this.staffs
        .filter((item) => {
          return (
            item["brand"] === this.selectedBrand &&
            item["firm"] === this.selectedFirm
          );
        })
        .map((item) => {
          return {
            text: item["staffName"],
            value: item[".key"],
          };
        });
    },
    // godawnByBrand() {
    //   return this.godawns
    //     .filter(item => {
    //       return (
    //         item["brand"] === this.selectedBrand
    //       );
    //     })
    //     .map(item => {
    //       return {
    //         text: item["godawnName"],
    //         value: item[".key"]
    //       };
    //     });
    // },
    banksByFirms() {
      return this.banks
        .filter((item) => {
          return (
            item["brand"] === this.selectedBrand &&
            item["firm"] === this.selectedFirm
          );
        })
        .map((item) => {
          return {
            text: item["bankName"],
            value: item[".key"],
          };
        });
    },
    totalItems() {
      return this.items.length || 0;
    },
    todaysDate() {
      let date = new Date();
      return `${date.getDate()}\\${date.getMonth()}\\${date.getYear()}`;
    },
    principalValueTotal() {
      let total = this.items.reduce(
        (accumulator, currentValue) =>
          accumulator + Number.parseFloat(currentValue.totlePrice),
        0
      );
      total +=Number.parseFloat(this.totalExtraCharges)
      total -=Number.parseFloat(this.discountAmount)
      // console.log(total)
      let newtotal = Math.round(Number.parseFloat(total));
      //  console.log(newtotal)
      this.roundOffAmount = Number.parseFloat(newtotal - total).toFixed(
        this.roundOff
      );
      return newtotal;
    },
  },
  mounted() {
    this.getCurrentUser();
  },
  updated() {
    this.expansionVal = true;
  },
  created() {
    this.invoiceDraft = {
      items: this.items,
      amountFromCash: this.amountFromCash || 0,
      amountFromBank: this.amountFromBank || 0,
      brand: this.selectedBrand,
      date: Date.now(),
      transferDetails: this.transferDetails,
      transferType: ["Cash", ""].includes(this.paymentType)
        ? "0"
        : this.transferType,
      duration: this.alertDuration, // days
      paymentType: this.paymentType,
      transactionType: this.transactionType,
      isCredited: false,
      firm: this.selectedFirm,
      bank: ["Cash", ""].includes(this.paymentType) ? 0 : this.selectedBank,
      totalAmount: this.principalValueTotal || 0,
      paidAmount: this.paidAmount || 0,
      remainingAmount: this.remainingAmount || 0,
      discountAmount: this.discountAmount || 0,
      roundOffAmount: this.roundOffAmount || 0,
      status: this.status,
      gstType: this.gstType,
      invoiceId: this.invoiceId,
      soldBy: this.soldBy,
      brokerageRate: this.brokerageRate,
      // godawnBy : this.godawnBy,
      placeOfSupply: this.placeOfSupply,
      totalTradeDiscount: this.totalTradeDiscount,
      totalSpecialCharge: this.totalSpecialCharge,
      remark: this.remark,
      orderNumber : this.orderNumber,
      applicationNumber : this.applicationNumber,
      sanctionDatepicker : this.sanctionDatepicker,
      sanctionDate : this.sanctionDate,
      orderDatepicker : this.orderDatepicker,
      orderDate : this.orderDate,
    };
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("staffs", this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand)),
    // this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn),
    this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("firmById", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("productById", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("orderById", this.$root.$firebaseRefs.orders.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("estimateById", this.$root.$firebaseRefs.estimates.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("batch", this.$root.$firebaseRefs.batchTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productSets", this.$root.$firebaseRefs.productSets.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('invoiceHistories', this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.$route.params.invoiceId) {
      this.getCurrentInvoice();
    }
  },
  watch: {
    items: {
      handler(newVal, oldVal) {
        this.updateAndEmit("totalAmount", this.principalValueTotal);
        this.totalAmount = this.principalValueTotal;
        this.calculateGSTType();
        this.calculateTotal();
        // this.updateAndEmit('totalCurrentAmount', this.currentValueTotal)
      },
      deep: true,
    },
    extraCharges: {
      handler(newVal, oldVal) {
        this.totalExtraCharges = 0;
        this.extraCharges.map((item)=>{
          this.totalExtraCharges += Number.parseFloat(item.amount)
        })
        this.totalAmount = this.principalValueTotal;
        this.calculateTotal();
        this.updateAndEmit("extraCharges", this.extraCharges);
        this.updateAndEmit("totalAmount", this.principalValueTotal);
      },
      deep: true,
    },
    orderNumber(newVal, oldVal) {
      if(!!newVal)
      this.updateAndEmit("orderNumber", newVal);
    },
    applicationNumber(newVal, oldVal) {
      if(!!newVal)
      this.updateAndEmit("applicationNumber", newVal);
    },
    sanctionDate(newVal, oldVal) {
      if(!!newVal)
      this.updateAndEmit("sanctionDate", new Date(newVal).getTime());
    },
    orderDate(newVal, oldVal) {
      if(!!newVal)
      this.updateAndEmit("orderDate", new Date(newVal).getTime());
    },
    isBuyer(newVal, oldVal) {
      this.updateAndEmit("isBuyer", newVal);
    },
    selectedBrand(newVal, oldVal) {
      this.updateAndEmit("brand", newVal);
    },
    status(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("status", newVal);
      }
    },
    transferDetails: {
      handler(newVal, oldVal) {
        if (newVal && this.invoiceDraft.transferDetails) {
          this.invoiceDraft.transferDetails.accountNumber =
            newVal.accountNumber;
          this.invoiceDraft.transferDetails.accountHolderName =
            newVal.accountHolderName;
          this.invoiceDraft.transferDetails.bankName = newVal.bankName;
          this.invoiceDraft.transferDetails.IFSCcode = newVal.IFSCcode;
          this.invoiceDraft.transferDetails.remark = newVal.remark;
        }
      },
      deep: true,
    },
    gstType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("gstType", newVal);
      }
    },
    placeOfSupply(newVal, oldVal) {
      if (oldVal !== newVal) {
        console.log(newVal);
        this.updateAndEmit("placeOfSupply", newVal);
        this.calculateGSTType();
      }
    },
    soldBy(newVal, oldVal) {
      if (oldVal !== newVal) {
        console.log(newVal);
        this.calculateBrokerage();
        this.updateAndEmit("soldBy", newVal);
      }
    },
    remark(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("remark", newVal);
      }
    },
    businessType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("businessType", newVal);
      }
    },
    brokerageRate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("brokerageRate", newVal);
      }
    },
    // godawnBy(newVal, oldVal) {
    //   if (oldVal !== newVal) {
    //     this.updateAndEmit("godawnBy", newVal);
    //   }
    // },
    transferType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("transferType", newVal);
      }
    },
    selectedBuyer(newVal, oldVal) {
      if (oldVal !== newVal && !!newVal) {
        this.updateAndEmit("buyerId", newVal[".key"]);
        this.getCurrentUser();
      }
    },
    alertDuration(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("duration", Number.parseInt(newVal));
      }
    },
    paymentType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("paymentType", newVal);
        if (this.selectedFirm != "") this.getFirmAndBankBalance();
        this.calculateTotal();
      }
    },
    transactionType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("transactionType", newVal);
        this.updateStatus();
        this.calculateTotal();
      }
    },

    invoiceDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("date", new Date(newVal).getTime());
      }
    },
    invoiceId(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("invoiceId", newVal);
      }
    },
    selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("firm", newVal);
        this.getFirmAndBankBalance();
        this.calculateGSTType();
      }
    },
    selectedBank(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("bank", newVal);
        if (this.selectedFirm != "") this.getFirmAndBankBalance();
      }
    },
    amountFromCash(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateTotal("amountFromCash");
      }
    },
    amountFromBank(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateTotal("amountFromBank");
      }
    },
    discountAmount(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("discountAmount", newVal);
        this.calculateTotal();
        this.totalAmount = this.principalValueTotal;
        this.updateAndEmit("totalAmount", this.principalValueTotal);
      }
    },
    roundOffAmount(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("roundOffAmount", newVal);
        //this.calculateTotal();
      }
    },
  },
  methods: {
    saveBillingData(){
      this.updateAndEmit("billingDetails", this.billingDetails);
      this.billingDetailsDialog = false;
    },
    saveProduct() {
        this.addProductDialog = false;
    },
    addProduct() {
      this.stepperValue = 1;
      this.currentProduct = {
        firm : null,
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        barcode:"",
        productType: null,
        productGroup: null,
        productCategory: null,
        unit: "",
        quantity: 0,
        batchNumber: "",
        openingDate : new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice : 0,
        gstValue : 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        purchasingPricePerProduct: null,
        unitsDetails : [
          {
            unit:'',
            isLast: true,
            isFirst:true,
            order : 1,
            quantity : 0
          }
        ]
      };
      this.addProductDialog = true;
    },
    getCurrentInvoice(){
        this.invoiceDraft = this.invoices.filter(item => item['.key'] === this.$route.params.invoiceId)[0];
        if(this.invoiceDraft.buyerId) {
            this.invoiceDraftPrevious = JSON.parse(JSON.stringify(this.invoiceDraft))
        }
         this.buyerId = this.invoiceDraft.buyerId
         this.isPaymentDone = this.invoiceDraft.status != 'due' ? true : false
        this.isBuyer = this.invoiceDraft.isBuyer
        this.items = this.invoiceDraft.items
        this.totalTradeDiscount = this.invoiceDraft.totalTradeDiscount
        this.amountFromCash = this.invoiceDraft.amountFromCash
        this.amountFromBank = this.invoiceDraft.amountFromBank
        this.alertDuration = this.invoiceDraft.duration
        this.paymentType = this.invoiceDraft.paymentType
        this.selectedBank = this.invoiceDraft.bank
        this.soldBy = this.invoiceDraft.soldBy
      this.brokerageRate = this.invoiceDraft.brokerageRate
        // this.godawnBy = '',
        this.placeOfSupply = this.invoiceDraft.placeOfSupply
        this.invoiceDate = new Date(this.invoiceDraft.date).toISOString().substr(0, 10)
        this.dateFormatted = new Date(this.invoiceDraft.date).toISOString().substr(0, 10)
        this.totalAmount = this.invoiceDraft.totalAmount
        this.paidAmount = this.invoiceDraft.paidAmount || 0
        this.remainingAmount = this.invoiceDraft.remainingAmount || 0
        this.discountAmount = this.invoiceDraft.discountAmount || 0
        this.roundOffAmount = this.invoiceDraft.roundOffAmount || 0
        // this.invoiceDraft= {},
        this.transferType = this.invoiceDraft.transferType
        this.availableBalance = this.invoiceDraft.availableBalance
        this.transactionType = this.invoiceDraft.transactionType
        this.status = this.invoiceDraft.status
        this.gstType = this.invoiceDraft.gstType
        this.remark = this.invoiceDraft.remark || ""
        this.invoiceId = this.invoiceDraft.invoiceId
        this.roundOff = this.invoiceDraft.roundOff
        this.orderNumber = this.invoiceDraft.orderNumber
        this.orderDate = this.invoiceDraft.orderDate
        this.orderDatepicker = this.invoiceDraft.orderDatepicker
        this.sanctionDate = this.invoiceDraft.sanctionDate
        this.sanctionDatepicker = this.invoiceDraft.sanctionDatepicker
        this.applicationNumber = this.invoiceDraft.applicationNumber
        if(this.invoiceDraft.billingDetails) {
          this.billingDetails.name = this.invoiceDraft.billingDetails.name || null;
          this.billingDetails.address = this.invoiceDraft.billingDetails.address || null;
          this.billingDetails.mobile = this.invoiceDraft.billingDetails.mobile || null;
        } 
        if(!this.invoiceDraft.transferDetails) {
             this.transferDetails = {
                accountNumber: null,
                accountHolderName: null,
                bankName: null,
                IFSCcode: null,
                remark: null,
            }
        } else {
            if(this.transferDetails.accountNumber) {
            this.transferDetails['accountNumber'] = this.invoiceDraft.transferDetails['accountNumber'];
          }
           if(this.transferDetails.accountHolderName) {
            this.transferDetails['accountHolderName'] = this.invoiceDraft.transferDetails['accountHolderName'];
          }
           if(this.transferDetails.bankName) {
            this.transferDetails['bankName'] = this.invoiceDraft.transferDetails['bankName'];
          }
           if(this.transferDetails.IFSCcode) {
            this.transferDetails['IFSCcode'] = this.invoiceDraft.transferDetails['IFSCcode'];
          }
           if(this.transferDetails.remark) {
            this.transferDetails['remark'] = this.invoiceDraft.transferDetails['remark'];
          }
        }
        
        this.isIncentive=(!!this.invoiceDraft.incentives && !!this.invoiceDraft.incentives.length );
        this.incentives=this.invoiceDraft.incentives || [];
        this.extraCharges=this.invoiceDraft.extraCharges || [];
        this.totalExtraCharges =this.invoiceDraft.totalExtraCharges;
        if (this.isBuyer) {
            this.selectedBuyer = this.buyers.filter(
            (item) => item[".key"] === this.buyerId
            )[0];
        } else {
            this.selectedBuyer = this.sellers.filter(
            (item) => item[".key"] === this.buyerId
            )[0];
        }
        let firm = this.firms.filter((item) => item[".key"] === this.invoiceDraft.firm)[0];
        this.selectedFirm = firm[".key"];
        this.selectedFirmState = firm["state"];
    },
    focusAddProduct(){
      setTimeout(() => {
        document.querySelector('.add-product-dropdown input').click();
      }, 500);
    },
    selectProductSet() {
      if(this.selectedProductSet) {
        this.addProductFromOrderItems(this.selectedProductSet);
      } else {
        this.items = [];
        this.calculateGSTType();
      }
      
    },
    changeIncentive() {
      if(this.isIncentive) {
        this.incentives.push({
          order:1,
          percentage:0
        })
      } else {
        this.incentives = [];
      }
       this.calculateGSTType();
    },
    addIncentive(event,inc){
      if (event.which == 13 || event.keyCode == 13) {
        this.incentives.push({
          order:inc.order+1,
          percentage:0
        })
        this.calculateGSTType();
      }
    },
    getProductsFromOrder() {
      let order = this.orderById[this.$route.params.orderId];
      let firm = this.firms.filter((item) => item[".key"] === order.firm)[0];
      this.selectedFirm = firm[".key"];
      this.selectedFirmState = firm["state"];
      this.isBuyer = order.isBuyer;
      if (this.isBuyer) {
        this.selectedBuyer = this.buyers.filter(
          (item) => item[".key"] === order.buyerId
        )[0];
      } else {
        this.selectedBuyer = this.sellers.filter(
          (item) => item[".key"] === order.buyerId
        )[0];
      }
      this.addProductFromOrderItems(order);
    },
    addProductFromOrderItems(order) {
      order.items.map((orderItem) => {
        let product = this.productById[orderItem.productId];
        let itemToAdd = {
          productId: orderItem.productId,
          quantity: orderItem.quantity,
          unit: orderItem.unit,
          taxableGST_rate: product.taxableGST_rate,
          HSN_code: product.HSN_code,
          productName: product.name,
          GST_type: product.GST_type,
          productUnit: product.unit,
          availableQuantity: product.quantity,
          tradeDiscount: 0,
          specialCharge: 0,
          rate: orderItem.rate,
        };
        itemToAdd.basicPrice = (
          Number.parseFloat(itemToAdd.rate * itemToAdd.quantity) -
          Number.parseFloat(itemToAdd.tradeDiscount) +
          Number.parseFloat(itemToAdd.specialCharge)
        ).toFixed(2);
        itemToAdd.GSTValue = Number.parseFloat(
          itemToAdd.basicPrice * (parseFloat(itemToAdd.taxableGST_rate) / 100)
        ).toFixed(2);
        itemToAdd.totlePrice = Number.parseFloat(
          Number.parseFloat(itemToAdd.basicPrice) +
            Number.parseFloat(itemToAdd.GSTValue)
        ).toFixed(2);

        let batchArray = this.batch.filter((item) => {
          return (
            item["brand"] === this.selectedBrand &&
            item["product"] === orderItem.productId
          );
        });
        batchArray.sort(function (a, b) {
          return -(new Date(b.expiryDate) - new Date(a.expiryDate));
        });
        if (batchArray.length) {
          itemToAdd.batchNumber = batchArray[0].batchNumber;
          itemToAdd.expiryDate = batchArray[0].expiryDate
            ? new Date(batchArray[0].expiryDate).toISOString().substr(0, 10)
            : new Date(new Date().setFullYear(new Date().getFullYear() + 100))
                .toISOString()
                .substr(0, 10);
          itemToAdd.manufacturingDate = batchArray[0].manufacturingDate
            ? new Date(batchArray[0].manufacturingDate)
                .toISOString()
                .substr(0, 10)
            : new Date(new Date().setFullYear(new Date().getFullYear() + 100))
                .toISOString()
                .substr(0, 10);
        } else {
          itemToAdd.expiryDate = new Date(
            new Date().setFullYear(new Date().getFullYear() + 100)
          )
            .toISOString()
            .substr(0, 10);
          itemToAdd.manufacturingDate = new Date(
            new Date().setFullYear(new Date().getFullYear() + 100)
          )
            .toISOString()
            .substr(0, 10);
          itemToAdd.batchNumber = "DEFAULT";
        }
        this.items.push(itemToAdd);
      });
      this.calculateGSTType();
    },
    getProductsFromEstimate() {
      let estimate = this.estimateById[this.$route.params.estimateId];
      let firm = this.firms.filter((item) => item[".key"] === estimate.firm)[0];
      this.selectedFirm = firm[".key"];
      this.selectedFirmState = firm["state"];
      this.isBuyer = estimate.isBuyer;
      if (this.isBuyer) {
        this.selectedBuyer = this.buyers.filter(
          (item) => item[".key"] === estimate.buyerId
        )[0];
      } else {
        this.selectedBuyer = this.sellers.filter(
          (item) => item[".key"] === estimate.buyerId
        )[0];
      }
      estimate.items.map((estimateItem) => {
        let product = this.productById[estimateItem.productId];
        let itemToAdd = {
          productId: estimateItem.productId,
          quantity: estimateItem.quantity,
          unit: estimateItem.unit,
          taxableGST_rate: product.taxableGST_rate,
          HSN_code: product.HSN_code,
          productName: product.name,
          GST_type: product.GST_type,
          productUnit: product.unit,
          availableQuantity: product.quantity,
          tradeDiscount: 0,
          specialCharge: 0,
          rate: estimateItem.rate,
        };
        itemToAdd.basicPrice = (
          Number.parseFloat(itemToAdd.rate * itemToAdd.quantity) -
          Number.parseFloat(itemToAdd.tradeDiscount) +
          Number.parseFloat(itemToAdd.specialCharge)
        ).toFixed(2);
        itemToAdd.GSTValue = Number.parseFloat(
          itemToAdd.basicPrice * (parseFloat(itemToAdd.taxableGST_rate) / 100)
        ).toFixed(2);
        itemToAdd.totlePrice = Number.parseFloat(
          Number.parseFloat(itemToAdd.basicPrice) +
            Number.parseFloat(itemToAdd.GSTValue)
        ).toFixed(2);

        let batchArray = this.batch.filter((item) => {
          return (
            item["brand"] === this.selectedBrand &&
            item["product"] === estimateItem.productId
          );
        });
        batchArray.sort(function (a, b) {
          return -(new Date(b.expiryDate) - new Date(a.expiryDate));
        });
        if (batchArray.length) {
          itemToAdd.batchNumber = batchArray[0].batchNumber;
          itemToAdd.expiryDate = batchArray[0].expiryDate
            ? new Date(batchArray[0].expiryDate).toISOString().substr(0, 10)
            : new Date(new Date().setFullYear(new Date().getFullYear() + 100))
                .toISOString()
                .substr(0, 10);
          itemToAdd.manufacturingDate = batchArray[0].manufacturingDate
            ? new Date(batchArray[0].manufacturingDate)
                .toISOString()
                .substr(0, 10)
            : new Date(new Date().setFullYear(new Date().getFullYear() + 100))
                .toISOString()
                .substr(0, 10);
        } else {
          itemToAdd.expiryDate = new Date(
            new Date().setFullYear(new Date().getFullYear() + 100)
          )
            .toISOString()
            .substr(0, 10);
          itemToAdd.manufacturingDate = new Date(
            new Date().setFullYear(new Date().getFullYear() + 100)
          )
            .toISOString()
            .substr(0, 10);
          itemToAdd.batchNumber = "DEFAULT";
        }
        this.items.push(itemToAdd);
      });
      this.calculateGSTType();
    },
    updateStatus() {
      switch (this.transactionType) {
        case "Debit": {
          this.updateAndEmit("status", "due");
          break;
        }
        case "Partial Paid": {
          this.updateAndEmit("status", "partial");
          // if (!this.transactionDialog) this.transactionDialog = true;
          break;
        }
        case "Credit": {
          this.updateAndEmit("status", "paid");
          // if (!this.transactionDialog) this.transactionDialog = true;
          break;
        }
      }
    },
    calculateBrokerage() {
      let staffObj = this.staffs.filter((item) => {
        return item[".key"] === this.soldBy;
      })[0];
      if (staffObj) {
        this.brokerageRate = Number.parseFloat(staffObj.brokerageRate);
        console.log(this.brokerageRate);
      }
    },
    formatDate() {
      var tomorrow = new Date(this.dateFormatted);
      tomorrow.setDate(tomorrow.getDate() + 1);
      this.invoiceDate = new Date(tomorrow).toISOString().substr(0, 10);
    },
    async basicInvoicePrint(isVertical) {
      this.updateAndEmit("totalExtraCharges", this.totalExtraCharges);
      this.updateStatus();
      let termsAndConditions = this.getTermsAndConditions();
      this.calculateGSTType();
      let firm = this.firmById[this.selectedFirm];
      firm.address = this.getAddress(firm);
      let customer = this.selectedBuyer;
      customer.address = this.getAddress(customer);
      if(isVertical) {
        if (this.gstInvoice) {
          await convertToBasicInvoice({
            invoiceData: this.invoiceDraft,
            firm: firm,
            customer: customer,
            gstTotal: this.GST_Val_total,
            terms: termsAndConditions[0],
          }).then((doc) => {
            pdfMake.createPdf(doc).download();
          });
        } else {
          await convertToBasicInvoiceWithoutGST({
            invoiceData: this.invoiceDraft,
            firm: firm,
            customer: customer,
            gstTotal: this.GST_Val_total,
            terms: termsAndConditions[0],
          }).then((doc) => {
            pdfMake.createPdf(doc).download();
          });
        }
      } else {
        if (this.gstInvoice) {
          await convertToBasicInvoiceHorizontal({
            invoiceData: this.invoiceDraft,
            firm: firm,
            customer: customer,
            gstTotal: this.GST_Val_total,
            terms: termsAndConditions[0],
          }).then((doc) => {
            pdfMake.createPdf(doc).download();
          });
        } else {
          await convertToBasicInvoiceWithoutGST({
            invoiceData: this.invoiceDraft,
            firm: firm,
            customer: customer,
            gstTotal: this.GST_Val_total,
            terms: termsAndConditions[0],
          }).then((doc) => {
            pdfMake.createPdf(doc).download();
          });
        }
      }
    },
    async printInvoice4(isSave) {
      this.updateAndEmit("totalExtraCharges", this.totalExtraCharges);
      this.updateStatus();
      let termsAndConditions = this.getTermsAndConditions();
      this.calculateGSTType();
      let firm = this.firmById[this.selectedFirm];
      firm.address = this.getAddress(firm);
      let customer = this.selectedBuyer;
      customer.address = this.getAddress(customer);
      await convertToSimpleInvoicePrint({
         invoiceData: this.invoiceDraft,
            firm: firm,
            customer: customer,
            gstTotal: this.GST_Val_total,
            terms: termsAndConditions[0],
      }).then((doc) => {
        // pdfMake.createPdf(doc).download(this.invoiceId);
        doc['info'] = {title : this.invoiceId}
        pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
      });
      if(isSave) {
        this.saveInvoice();
      }
    },
    getTermsAndConditions() {
      let termsAndConditions = this.termsAndConditions.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["firm"] === this.selectedFirm
      );
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.bankById[bankId];
            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      return termsAndConditions;
    },
    getAddress(item) {
      if (!item) {
        return "";
      }
      let address =
        (item.village ? item.village + ", " : "") +
        (item.block ? item.block + ", " : "") +
        (item.tehsil ? item.tehsil + ", " : "") +
        (item.district ? item.district + ", " : "") +
        (item.state ? item.state + ", " : "") +
        (item.country ? item.country + ", " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    resetAmounts() {
      this.amountFromCash = 0;
      this.amountFromBank = 0;
      this.discountAmount = 0;
    },

    // NEw Development
    getFirmAndBankBalance() {
      let selectedFirm = this.firms.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item[".key"] == this.selectedFirm
      );
      this.businessType = selectedFirm[0].businessType;
      this.gstInvoice =
        selectedFirm[0].GST_user && selectedFirm[0].GST_user == "Yes"
          ? true
          : false;
      let selectedBank = this.selectedBank
        ? this.banks.filter(
            (item) =>
              item["brand"] === this.selectedBrand &&
              item[".key"] == this.selectedBank
          )
        : null;
      switch (this.paymentType) {
        case "Cash": {
          if (this.selectedFirm) {
            this.availableBalance =
              selectedFirm.length &&
              (selectedFirm[0]["amount"] ? selectedFirm[0]["amount"] : 0);
          } else {
            this.availableBalance = 0;
          }
          break;
        }
        case "Bank Account": {
          if (this.selectedBank) {
            this.availableBalance =
              selectedBank.length &&
              (selectedBank[0]["amount"] ? selectedBank[0]["amount"] : 0);
          } else {
            this.availableBalance = 0;
          }
          break;
        }
        case "CashAndBank Account": {
          if (this.selectedFirm && this.selectedBank) {
            this.availableBalance =
              selectedFirm.length &&
              selectedBank.length &&
              (selectedBank[0]["amount"] ? selectedBank[0]["amount"] : 0) +
                (selectedFirm[0]["amount"] ? selectedFirm[0]["amount"] : 0);
          } else {
            this.availableBalance = 0;
          }
          break;
        }
      }
    },
    editItem(item, fromDialog) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.isEditItems = true;
      if (!fromDialog) {
        this.dialog = true;
      }
    },
    deleteItem(item) {
      const index = this.items.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.items.splice(index, 1);
    },
    close(saveAddItem) {
      if (!saveAddItem) {
        this.dialog = false;
      }
      else {
        this.focusAddProduct()
      }
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    calculateTotal(type) {
      let discountAmount = Number.parseFloat(this.discountAmount);
      let amountFromBank = Number.parseFloat(this.amountFromBank);
      let amountFromCash = Number.parseFloat(this.amountFromCash);
      let totalAmount = Number.parseFloat(this.totalAmount);
      switch (this.paymentType) {
        case "Cash": {
          this.amountFromBank = 0;
          this.amountFromBankDisabled = true;
          switch (this.transactionType) {
            case "Debit": {
              this.amountFromCashDisabled = true;
              this.amountFromCash = totalAmount;
              this.remainingAmount = totalAmount;
              this.paidAmount = 0;
              break;
            }
            case "Partial Paid": {
              this.amountFromCashDisabled = false;
              this.remainingAmount =
                totalAmount - (amountFromCash);
              this.paidAmount = amountFromCash;
              break;
            }
            case "Credit": {
              this.amountFromCashDisabled = true;
              this.amountFromCash = totalAmount;
              this.remainingAmount = 0;
              this.paidAmount = totalAmount;
              break;
            }
          }
          break;
        }
        case "Bank Account": {
          this.amountFromCashDisabled = true;
          this.amountFromCash = 0;
          switch (this.transactionType) {
            case "Debit": {
              this.amountFromBankDisabled = true;
              this.amountFromBank = totalAmount;
              this.remainingAmount = totalAmount;
              this.paidAmount = 0;
              break;
            }
            case "Partial Paid": {
              this.amountFromBankDisabled = false;
              this.remainingAmount =
                totalAmount - (amountFromBank);
              this.paidAmount = amountFromBank;
              break;
            }
            case "Credit": {
              this.amountFromBankDisabled = true;
              this.amountFromBank = totalAmount;
              this.remainingAmount = 0;
              this.paidAmount = totalAmount;
              break;
            }
          }
          break;
        }
        case "CashAndBank Account": {
          this.amountFromCashDisabled = false;
          this.amountFromBankDisabled = false;
          let totalBankAndCash = amountFromCash + amountFromBank;
          switch (this.transactionType) {
            case "Debit": {
              this.remainingAmount = totalAmount;
              this.paidAmount = 0;
              break;
            }
            case "Partial Paid": {
              this.paidAmount = totalBankAndCash;
              this.remainingAmount =
                totalAmount - (paidAmount);
              break;
            }
            case "Credit": {
              this.remainingAmount = 0;
              this.paidAmount = totalAmount;
              break;
            }
          }
          break;
        }
        case "": {
          this.amountFromCashDisabled = true;
          this.amountFromBankDisabled = true;
          this.amountFromCash = 0;
          this.amountFromBank = 0;
          this.paidAmount = 0;
          this.remainingAmount = totalAmount;
          break;
        }
      }
      this.paidAmount = Number.parseFloat(this.paidAmount).toFixed(
        parseInt(this.roundOff)
      );
      if (type != "amountFromCash")
        this.amountFromCash = Number.parseFloat(this.amountFromCash).toFixed(
          parseInt(this.roundOff)
        );
      if (type != "amountFromBank")
        this.amountFromBank = Number.parseFloat(this.amountFromBank).toFixed(
          parseInt(this.roundOff)
        );
      this.remainingAmount = Number.parseFloat(this.remainingAmount).toFixed(
        parseInt(this.roundOff)
      );
      this.updateAndEmit("paidAmount", this.paidAmount);
      this.updateAndEmit("amountFromCash", this.amountFromCash);
      this.updateAndEmit("amountFromBank", this.amountFromBank);
      this.updateAndEmit("remainingAmount", this.remainingAmount);
    },
    save(editedItem, saveAndAdd) {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], editedItem);
      } else {
        this.items.push(editedItem);
      }
      this.calculateGSTType();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.isEditItems = false;
      }, 300);
      this.close(saveAndAdd);
    },
    calculateGSTType() {
      if (this.selectedBuyer) {
        this.GST_Val_total.SGST_val = 0;
        this.GST_Val_total.CGST_val = 0;
        this.GST_Val_total.IGST_val = 0;
        if(this.isIncentive) {
          this.incentives.sort(function(a,b){
            return (new Date(a.order) - new Date(b.order));
          });
        }
        let isProductRoundOff = this.firmSetting && this.firmSetting.roundOff
        this.items.map((item, index) => {
          let GST = item["taxableGST_rate"];
          let firm = this.firmById[this.selectedFirm];
          let itemIncentive = 0;
          this.incentives.map((inc)=>{
            if(!!inc.percentage) {
              itemIncentive += ((parseFloat(item.basicPrice)-parseFloat(itemIncentive)) * (parseFloat(inc.percentage)/100))
            }
          });
          item.incentiveAmount = itemIncentive;
          if(isProductRoundOff) {
            let GSTValue = Number.parseFloat((item.basicPrice - itemIncentive) * (parseFloat(item.taxableGST_rate)/100)).toFixed(2);
            let totlePrice = Number.parseFloat((Number.parseFloat(item.basicPrice - itemIncentive) + Number.parseFloat(item.GSTValue))).toFixed(2);
            item.GSTValue = Math.round(Number.parseFloat(GSTValue));
            item.totlePrice = Math.round(Number.parseFloat(totlePrice));
          } else {
            item.GSTValue = Number.parseFloat((item.basicPrice - itemIncentive) * (parseFloat(item.taxableGST_rate)/100)).toFixed(2);
            item.totlePrice = Number.parseFloat((Number.parseFloat(item.basicPrice - itemIncentive) + Number.parseFloat(item.GSTValue))).toFixed(2);
          }
          if (
            !this.selectedBuyer.state ||
            (this.selectedFirm &&
              this.selectedBuyer.state &&
              Number.parseFloat(GST) &&
              firm.state === this.placeOfSupply)
          ) {
            item["CGST_val"] = item["GSTValue"] / 2;
            item["CGST"] = GST / 2;
            item["SGST_val"] = item["GSTValue"] / 2;
            item["SGST"] = GST / 2;
            item["IGST"] = 0;
            item["IGST_val"] = 0;
            this.GST_Val_total.SGST_val += Number.parseFloat(item["SGST_val"]);
            this.GST_Val_total.CGST_val += Number.parseFloat(item["CGST_val"]);
            this.GST_Val_total.IGST_val += Number.parseFloat(item["IGST_val"]);
            this.updateAndEmit("gstType", "SGST|CGST");
          } else {
            item["IGST"] = GST;
            item["CGST"] = 0;
            item["SGST"] = 0;
            item["IGST_val"] = item["GSTValue"];
            item["CGST_val"] = 0;
            item["SGST_val"] = 0;
            this.GST_Val_total.SGST_val += Number.parseFloat(item["SGST_val"]);
            this.GST_Val_total.CGST_val += Number.parseFloat(item["CGST_val"]);
            this.GST_Val_total.IGST_val += Number.parseFloat(item["IGST_val"]);
            this.updateAndEmit("gstType", "IGST");
            this.totalTradeDiscount += Number.parseFloat(item["tradeDiscount"]);
            this.totalSpecialCharge += Number.parseFloat(item["specialCharge"]);
          }
          this.items[index] = item;
        });
        this.GST_Percentage_total = getGSTPercentageTotal(this.items);
        this.updateAndEmit("items", this.items);
        this.updateAndEmit("tradeDiscount", this.totalTradeDiscount);
        this.updateAndEmit("specialCharge", this.totalSpecialCharge);
      }
    },    
    updateAndEmit(key, value) {
      this.invoiceDraft[key] = value;
    },
    saveAndPrint(vertical) {
      this.basicInvoicePrint(vertical);
      this.saveInvoice();
    },
    ewayBillSave(ewayBillDetails){
      this.updateAndEmit("ewayBillDetails", ewayBillDetails);
      // this.ewayBillDialog = false;
      this.saveInvoice();
    },
    eWayBillPrint(){
      this.updateStatus();
      this.updateAndEmit("isBuyer", this.isBuyer);
      this.updateAndEmit("transactionType", this.transactionType);
      this.updateAndEmit("buyerId", this.selectedBuyer[".key"]);
      this.updateAndEmit("totalExtraCharges", this.totalExtraCharges);
      this.updateAndEmit("extraCharges", this.extraCharges);
      this.updateAndEmit("incentives", this.incentives);
      this.updateAndEmit("totalAmount", this.principalValueTotal);
      // this.ewayBillDialog = true;
    },
    saveInvoice() {
      this.updateStatus();
      this.updateAndEmit("isBuyer", this.isBuyer);
      this.updateAndEmit("transactionType", this.transactionType);
      this.updateAndEmit("buyerId", this.selectedBuyer[".key"]);
      this.updateAndEmit("totalExtraCharges", this.totalExtraCharges);
      this.updateAndEmit("extraCharges", this.extraCharges);
      this.updateAndEmit("incentives", this.incentives);
      this.updateAndEmit("totalAmount", this.principalValueTotal);
      //this.updateInvoice(this.invoiceDraft);
     var p = new Ping({timeout : 3000});
      p.ping("http://google.com", (err, data)=> {
        // Also display error if err is returned.
        if (err) {
          this.snackbar = true;
          this.snackbarMsg = 'It seems like you are offline. Check your Internet Connectivity.';
          console.log("error loading resource")
          data = data + " " + err;
        } else {
          this.snackbar = false;
          if(this.firmSetting && this.firmSetting.verifiedInvoice) {
            let firm = this.firms.filter(item => item['.key'] == this.selectedFirm)[0]
            if(firm.mobileNumber) {
              this.otpData.mobile = firm.mobileNumber;
              this.otpData.otp = Math.floor(100000 + Math.random() * 900000)
              let message = `OTP for Invoice of Amount ₹${Number.parseFloat(this.totalAmount).toFixed(2)} under ${this.selectedBuyer.name ? this.selectedBuyer.name : ''} is ${this.otpData.otp}. Please enter otp in portal to continue.`;
              this.snackbar = true;
              this.snackbarMsg = 'Sending verification OTP.';
              sendSms(["+91"+firm.mobileNumber],message).then((response)=>{
                console.log(response);
                this.otpData.dialog = true;
              })
            }
          } else {
            this.updateInvoice(this.invoiceDraft);
          }
        }
      });
    },
    confirmOTP(){
      if(this.otpData.otp == this.otpData.confirmOtp) {
        this.updateInvoice(this.invoiceDraft);
        this.otpData.dialog = false;
      }
    },
    getCurrentUser() {
      this.placeOfSupply = this.selectedBuyer ? this.selectedBuyer.state : null;
      if (!this.selectedFirm) {
        // if(this.selectedBuyer && this.selectedBuyer.defaultFirm) {
        //   this.selectedFirm = this.selectedBuyer.defaultFirm;
        // }
        // else {
        let defaultFirm = this.firms.filter(
          (item) =>
            item["brand"] === this.selectedBrand && !!item["defaultFirm"]
        )[0];
        this.selectedFirm = defaultFirm[".key"];
        this.selectedFirmState = defaultFirm["state"];
        if(!this.placeOfSupply && this.selectedFirmState) {
          this.placeOfSupply = this.selectedFirmState;
        }
        this.businessType = defaultFirm["businessType"];
        //}
      }
      this.getFirmAndBankBalance();
    },

    updateInvoice (invoiceData) {
      console.log('Update Invoice Called')
      this.manageBeforePayments(invoiceData['.key']);
      if(invoiceData.transferDetails) {

      }
      // this.dialog = false
      console.info(invoiceData);
      const updated_at = new Date().getTime()
      // debugger
      try {
        //   invoiceData['items'].forEach((item, index) => {
        //   item['date'] = invoiceData['date']
        //   if(item.id) {
        //     item['updated_at'] = updated_at;
        //     this.$root.$firebaseRefs.item.child(item['id']).update(item, () => {
        //       console.info('item updated...')
        //     })
        //   } else {
        //     const response = this.$root.$firebaseRefs.item.push(item, () => {
        //       console.info('item pushed...')
        //     })
        //     invoiceData['items'][index]['id'] = response['key']
        //   }
        // })
        invoiceData['updated_at'] = updated_at;
        let key = invoiceData['.key'];
        delete invoiceData['.key']
        
        this.$root.$firebaseRefs.invoice.child(key).update(invoiceData, () => {
          console.info('invoice updated...')
          this.managePayments(invoiceData);
        })
        invoiceData['parentInvoiceKey'] = key;
       
          let histories = this.invoiceHistories.filter(item =>
          item['brand'] == this.selectedBrand &&
          item['parentInvoiceKey'] == key
          )
          // if(this.isPaymentDone) {
          //   histories.map((h)=>{
          //     this.$root.$firebaseRefs.buyer.invoiceHistory(h['.key']).remove();
          //   })
          //   invoiceData["newlyCreated"] = true;
          //   invoiceData["isLatest"] = true;
          //   this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
          // } else {
            histories.map((h)=>{
                if(h.isLatest == true || h.isLatest == false) {
                    invoiceData['isLatest'] = h.isLatest;
                } else {
                    delete invoiceData['isLatest']
                }

                if(h.newlyCreated == true || h.newlyCreated == false) {
                    invoiceData['newlyCreated'] = h.newlyCreated;
                } else {
                    delete invoiceData['newlyCreated']
                }
                let key = h['.key']
              this.$root.$firebaseRefs.invoiceHistory.child(key).update(invoiceData, () => {
              })
            })
          //}
      } catch(e) {
        console.info('Error at update Invoice', e)
      }
    //this.$router.push({path: `/buyers/${this.selectedBuyer['.key']}` })
    },
    sendNotification(){
      if(this.selectedBuyer.mobile) {
        let message = `Hi, ${this.selectedBuyer.name ? this.selectedBuyer.name : ''} Invoice of Amount ₹${Number.parseFloat(this.totalAmount).toFixed(2)} has been created. Thank You!`;
        sendSms(["+91"+this.selectedBuyer.mobile],message)
      }
    this.sendWhatsappNotificationToBrandAdmin();
    },
    sendWhatsappNotificationToBrandAdmin(){
      let message = `Invoice of amount ₹${Number.parseFloat(this.totalAmount).toFixed(2)} has been created, under ${this.selectedBuyer.name ? this.selectedBuyer.name : ''}.`;
      let adminUsers = this.operatorsList.filter(
          (item) => (item["brand"] === this.selectedBrand && item["role"] == 'admin')
        );
      let mobileNumbers = []
      adminUsers.map((user)=>{
        if(user.mobile && user.notificationWSAPP) {
          mobileNumbers.push(("+91"+user.mobile))
        }
      })
      sendWhatsApp(mobileNumbers,message)
    },
    managePayments(invoiceData){
      //let beforeUpdateInvoice = this.invoices.filter(item => item['.key'] === invoiceData['.key'])[0];
       switch(invoiceData.paymentType) {
          case 'Cash' : {
            if(invoiceData.amountFromCash) {
              let firm = this.firms.filter(item => item['.key'] == invoiceData.firm)[0]
              if(firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = this.isBuyer ? (Number.parseFloat(firm.amount) + Number.parseFloat(invoiceData.amountFromCash)) : (Number.parseFloat(firm.amount) - Number.parseFloat(invoiceData.amountFromCash));   
                delete firm['.key']
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
          case 'Bank Account' : {
            if(invoiceData.amountFromBank) {
              let bank =  this.banks.filter(item => item['.key'] == invoiceData.bank)[0]
              if(bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = this.isBuyer ? (Number.parseFloat(bank.amount) + Number.parseFloat(invoiceData.amountFromBank)) : (Number.parseFloat(bank.amount) - Number.parseFloat(invoiceData.amountFromBank)) ;  
                delete bank['.key']
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
          case 'CashAndBank Account' : {
            if(invoiceData.amountFromCash && invoiceData.amountFromBank) {
              let bank = this.banks.filter(item => item['.key'] == invoiceData.bank)[0]
              if(bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = this.isBuyer ? Number.parseFloat(bank.amount) + Number.parseFloat(invoiceData.amountFromBank) : Number.parseFloat(bank.amount) - Number.parseFloat(invoiceData.amountFromBank);  
                delete bank['.key']
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
              let firm = this.firms.filter(item => item['.key'] == invoiceData.firm)[0]
              if(firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = this.isBuyer ? Number.parseFloat(firm.amount) + Number.parseFloat(invoiceData.amountFromCash) : Number.parseFloat(firm.amount) - Number.parseFloat(invoiceData.amountFromCash);
                delete firm['.key']
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }         
            }
            break;
          }
        }
        this.manageProductsQuantity(invoiceData);
    },
    manageProductsQuantity(invoiceData){
        invoiceData.items.map((item) => {
        let key = item['productId'];
        let product = this.productById[key];
        if(this.isBuyer) {
          let saleQuantity = product['saleQuantity'] ? product['saleQuantity'] : 0;
          saleQuantity = saleQuantity + Number.parseInt(item.quantity)
          product['saleQuantity'] = saleQuantity;
        } else {
          let purchaseQuantity = product['purchaseQuantity'] ? product['purchaseQuantity'] : 0;
          purchaseQuantity = purchaseQuantity + Number.parseInt(item.quantity)
          product['purchaseQuantity'] = purchaseQuantity;
        }
        let prodQuantity = product['quantity'];
        prodQuantity = this.isBuyer ? (Number.parseInt(prodQuantity) - Number.parseInt(item.quantity)) : (Number.parseInt(prodQuantity) + Number.parseInt(item.quantity));
        delete product['.key'];
        product['quantity'] = prodQuantity;
        this.$root.$firebaseRefs.products.child(key).set(product);
      });
      this.snackbarSuccess = true;
      this.resetInvoice();
    },
    manageBeforePayments(key){
      let invoiceData = this.invoiceDraftPrevious;
       switch(invoiceData.paymentType) {
          case 'Cash' : {
            if(invoiceData.amountFromCash) {
              let firm = this.firms.filter(item => item['.key'] == invoiceData.firm)[0]
              if(firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = this.isBuyer ? (Number.parseFloat(firm.amount) - Number.parseFloat(invoiceData.amountFromCash)) : (Number.parseFloat(firm.amount) + Number.parseFloat(invoiceData.amountFromCash));   
                delete firm['.key']
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
          case 'Bank Account' : {
            if(invoiceData.amountFromBank) {
              let bank = this.banks.filter(item => item['.key'] == invoiceData.bank)[0]
              if(bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = this.isBuyer ? (Number.parseFloat(bank.amount) - Number.parseFloat(invoiceData.amountFromBank)) : (Number.parseFloat(bank.amount) + Number.parseFloat(invoiceData.amountFromBank)) ;  
                delete bank['.key']
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
          case 'CashAndBank Account' : {
            if(invoiceData.amountFromCash && invoiceData.amountFromBank) {
              let bank = this.banks.filter(item => item['.key'] == invoiceData.bank)[0]
              if(bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = this.isBuyer ? Number.parseFloat(bank.amount) - Number.parseFloat(invoiceData.amountFromBank) : Number.parseFloat(bank.amount) + Number.parseFloat(invoiceData.amountFromBank);  
                delete bank['.key']
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
              let firm = this.firms.filter(item => item['.key'] == invoiceData.firm)[0]
              if(firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = this.isBuyer ? Number.parseFloat(firm.amount) - Number.parseFloat(invoiceData.amountFromCash) : Number.parseFloat(firm.amount) + Number.parseFloat(invoiceData.amountFromCash);
                delete firm['.key']
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }         
            }
            break;
          }
        }
        this.manageBeforeProductsQuantity(invoiceData);
    },
    manageBeforeProductsQuantity(invoiceData){
      invoiceData.items.map((item) => {
        let key = item['productId'];
        let product = this.productById[key];
        if(this.isBuyer) {
          let saleQuantity = product['saleQuantity'] ? product['saleQuantity'] : 0;
          saleQuantity = saleQuantity - Number.parseInt(item.quantity)
          product['saleQuantity'] = saleQuantity;
        } else {
          let purchaseQuantity = product['purchaseQuantity'] ? product['purchaseQuantity'] : 0;
          purchaseQuantity = purchaseQuantity - Number.parseInt(item.quantity)
          product['purchaseQuantity'] = purchaseQuantity;
        }
        let prodQuantity = product['quantity'];
        prodQuantity = this.isBuyer ? (Number.parseInt(prodQuantity) + Number.parseInt(item.quantity)) : (Number.parseInt(prodQuantity) - Number.parseInt(item.quantity));
        delete product['.key'];
        product['quantity'] = prodQuantity;
        this.$root.$firebaseRefs.products.child(key).set(product);
      })
    },
  
    
    addBatchDetails(product, isBuyer) {
      console.log("adding batch details");
      console.log(product);
      let batchArray = this.batch.filter((item) => {
        return (
          item["batchNumber"] == product.batchNumber &&
          item["brand"] === this.selectedBrand &&
          item["product"] === product.productId
        );
      });
      if (batchArray.length) {
        // let batchObj = batchArray[0];
        let batchObj = JSON.parse(JSON.stringify(batchArray[0]));
        batchObj.quantity = isBuyer
          ? batchObj.quantity - product.quantity
          : batchObj.quantity + product.quantity;
        let key = batchObj[".key"];
        delete batchObj[".key"];
        this.$root.$firebaseRefs.batchTransaction.child(key).set(batchObj);
      } else {
        let batchObj = {
          quantity: isBuyer ? -product.quantity : product.quantity,
          // expiryDate : product.expiryDate,
          // manufacturingDate :product.manufacturingDate,
          expiryDate: new Date(product.expiryDate).getTime(),
          manufacturingDate: new Date(product.manufacturingDate).getTime(),
          product: product.productId,
          batchNumber: product.batchNumber,
          brand: this.selectedBrand,
          createdDate: new Date().getTime(),
        };
        this.$root.$firebaseRefs.batchTransaction.push(batchObj);
      }
      delete product["expiryDate"];
      delete product["manufacturingDate"];
      delete product["batchNumber"];
    },

    resetInvoice() {
      this.$router.push({path: `/buyers/${this.selectedBuyer['.key']}` })
      (this.selectedBuyer = null),
        (this.isBuyer = true),
        (this.isEditItems = false),
        (this.duplicateError = null),
        (this.items = []),
        (this.totalTradeDiscount = 0),
        (this.totalSpecialCharge = 0),
        (this.editedIndex = -1),
        (this.editedItem = {
          productName: "",
          productId: "",
          HSN_code: "",
          taxableGST_rate: 0,
          rate: 0,
          unit: "",
          quantity: 0,
          basicPrice: 0,
          GSTValue: 0,
          totlePrice: 0,
          tradeDiscount: 0,
          specialCharge: 0,
        }),
        (this.defaultItem = {
          productName: "",
          productId: "",
          HSN_code: "",
          taxableGST_rate: 0,
          rate: 0,
          unit: "",
          quantity: 0,
          basicPrice: 0,
          GSTValue: 0,
          totlePrice: 0,
          tradeDiscount: 0,
          specialCharge: 0,
        }),
        (this.amountFromCash = 0),
        (this.amountFromBank = 0),
        (this.alertDuration = 0),
        (this.paymentType = ""),
        // this.selectedFirm= "",
        (this.selectedBank = ""),
        (this.soldBy = ""),
        (this.brokerageRate = 0),
        // this.godawnBy = '',
        (this.placeOfSupply = ""),
        (this.invoiceDate = new Date().toISOString().substr(0, 10)),
        (this.dateFormatted = new Date().toISOString().substr(0, 10)),
        (this.datepicker = false),
        (this.totalAmount = 0),
        (this.paidAmount = 0),
        (this.remainingAmount = 0),
        (this.discountAmount = 0),
        (this.roundOffAmount = 0),
        // this.invoiceDraft= {},
        (this.transferType = null),
        (this.transferTypeDialog = false),
        (this.availableBalance = 0),
        (this.transactionType = "Debit"),
        (this.amountFromCashDisabled = true),
        (this.amountFromBankDisabled = true),
        (this.status = null),
        (this.gstType = null),
        (this.currentUser = null),
        (this.remark = null),
        (this.invoiceId = null),
        (this.GST_Val_total = {
          CGST_val: 0,
          SGST_val: 0,
          IGST_val: 0,
        }),
        (this.GST_Percentage_total = {
          GST_0: 0,
          GST_5: 0,
          GST_12: 0,
          GST_18: 0,
          GST_28: 0,
        }),
        (this.roundOff = 2),
        (this.transactionDialog = false),
        (this.expansionVal = false),
        (this.transferDetails = {
          accountNumber: null,
          accountHolderName: null,
          bankName: null,
          IFSCcode: null,
          remark: null,
        });
        this.isIncentive=false;
        this.incentives=[];
        this.extraCharges=[];
        this.totalExtraCharges = 0;
      this.invoiceDraft = {
        items: this.items,
        amountFromCash: this.amountFromCash || 0,
        amountFromBank: this.amountFromBank || 0,
        brand: this.selectedBrand,
        date: Date.now(),
        transferDetails: this.transferDetails,
        transferType: ["Cash", ""].includes(this.paymentType)
          ? "0"
          : this.transferType,
        duration: this.alertDuration, // days
        paymentType: this.paymentType,
        transactionType: this.transactionType,
        isCredited: false,
        firm: this.selectedFirm,
        bank: ["Cash", ""].includes(this.paymentType) ? 0 : this.selectedBank,
        totalAmount: this.principalValueTotal || 0,
        paidAmount: this.paidAmount || 0,
        remainingAmount: this.remainingAmount || 0,
        discountAmount: this.discountAmount || 0,
        roundOffAmount: this.roundOffAmount || 0,
        status: this.status,
        gstType: this.gstType,
        invoiceId: this.invoiceId,
        soldBy: this.soldBy,
        brokerageRate: this.brokerageRate,
        // godawnBy : this.godawnBy,
        placeOfSupply: this.placeOfSupply,
        totalTradeDiscount: this.totalTradeDiscount,
        totalSpecialCharge: this.totalSpecialCharge,
        remark: this.remark,
      };
      this.selectedProductSet = null;

      this.updateAndEmit("date", new Date(this.invoiceDate).getTime());
      setTimeout(() => {
        this.getCurrentUser();
      }, 1000);
    },
    addCharges:function (e) {
      let obj = {
        name: e.target.value,
        amount: 0,
      };
      this.extraChargesSample.push(obj)
    },
    addCustomer: function (e) {
      this.getCurrentUser();
      let obj = {
        name: e.target.value,
        brand: this.selectedBrand,
      };
      if (this.selectedFirmState) {
        obj["state"] = this.selectedFirmState;
      }

      if (this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    },
  },
  mounted() {
    let self = this;
    this._keyListener = function(e) {
              var key;
              var isShift;
              if (window.event) {
                key = window.event.keyCode;
                isShift = !!window.event.shiftKey; // typecast to boolean
              } else {
                key = ev.which;
                isShift = !!ev.shiftKey;
              }
              if ( isShift ) {
                switch (key) {
                  case 16: // ignore shift key
                    break;
                  default: {
                    switch (window.event.key) {
                        case 'N' :{
                          self.dialog = true;
                          console.log('add new item');
                          break;
                        }
                        case 'A' :{
                          if (self.dialog) {
                            let btn = document.getElementsByClassName('add-save-btn-add-icons');
                            if(!btn[0].classList.contains('v-btn--disabled')) {
                              document.getElementsByClassName('add-save-btn-add-icons')[0].click()
                            }
                            console.log('save and add');
                          }
                          break;
                        }
                        case 'S' :{
                          if (self.dialog) {
                            let btn = document.getElementsByClassName('add-btn-add-icons');
                            if(!btn[0].classList.contains('v-btn--disabled')) {
                              document.getElementsByClassName('add-btn-add-icons')[0].click()
                            }
                            console.log('save');
                          }
                          break;
                        }
                        case 'C' :{
                          if (self.dialog) {
                              document.getElementsByClassName('cancel-btn-add-icons')[0].click()
                             console.log('cancel');
                          }
                          break;
                        }
                         case 'W' :{
                            //document.getElementsByClassName('js-customer-switcher')[0].click()
                            this.isBuyer = !this.isBuyer;
                            setTimeout(() => {
                              document.querySelector('.js-select-buyer input').click();
                            }, 1000);
                            console.log('cancel');
                          break;
                        }
                        case 'P' :{
                          if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                              self.saveAndPrint(true)
                              console.log('save and print');
                          }
                          break;
                        }
                        case 'Z' :{
                          if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                              self.saveInvoice(true)
                              console.log('save');
                          }
                          break;
                        }
                        case 'H' :{
                          if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                              self.basicInvoicePrint(false);
                              console.log('horizontal print');
                          }
                          break;
                        }
                        case 'V' :{
                          if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                              self.basicInvoicePrint(true);
                              console.log('vertical print');
                          }
                          break;
                        }
                         case 'E' :{
                          if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                              self.eWayBillPrint();
                              console.log('eway print');
                          }
                          break;
                        }
                         case 'G' :{
                          this.$router.push({ path: `/settings/product-grouping/true/invoice` });
                          break;
                        }
                        case 'T' :{
                          this.$router.push({ path: `/settings/product-set/true/invoice` });
                          break;
                        }
                      break;
                  }
                }
              }
        };
    }
    //document.addEventListener('keydown', this._keyListener.bind(this));
    this._keyListener1 = function(e) {      
      if (window.event.keyCode == 73 &&  window.event.ctrlKey) {
        //ctrl + i
        window.event.preventDefault();
        self.dialog = true;
        console.log('add new item');
      }
      if (window.event.keyCode == 32) {
        // space 
        if (self.dialog) {
          let btn = document.getElementsByClassName('add-save-btn-add-icons');
          if(!btn[0].classList.contains('v-btn--disabled')) {
            window.event.preventDefault();
            document.getElementsByClassName('add-save-btn-add-icons')[0].click()
            console.log('save and add');
          }
          
        }
      }
       if (window.event.keyCode == 13) {
        //enter
         if (self.dialog) {
            window.event.preventDefault();
            let btn = document.getElementsByClassName('add-btn-add-icons');
            if(!btn[0].classList.contains('v-btn--disabled')) {
              document.getElementsByClassName('add-btn-add-icons')[0].click()
            }
            console.log('save');
          }
      }
       if (window.event.keyCode == 27) {
        //escape
        if (self.dialog) {
          window.event.preventDefault();
            document.getElementsByClassName('cancel-btn-add-icons')[0].click()
            console.log('cancel');
        }
      }
       if (window.event.keyCode == 70 &&  window.event.ctrlKey) {
        //ctrl + f
        this.isBuyer = !this.isBuyer;
        window.event.preventDefault();
        setTimeout(() => {
          document.querySelector('.js-select-buyer input').click();
        }, 1000);
        console.log('switch to purchase/sale');
      }
      if (window.event.keyCode == 80 &&  window.event.ctrlKey) {
        //ctrl + p
        if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
            window.event.preventDefault();
            self.saveAndPrint(true)
            console.log('Save and Print');
        }
      }
      if (window.event.keyCode == 83 &&  window.event.ctrlKey) {
        //ctrl + s
        if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
            window.event.preventDefault();
            self.saveInvoice(true)
            console.log('Save Invoice');
        }
      }
       if (window.event.keyCode == 72 &&  window.event.ctrlKey) {
        //ctrl + h
        if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
            window.event.preventDefault();
            self.basicInvoicePrint(false);
            console.log('horizontal print');
        }
      }
       if (window.event.keyCode == 86 &&  window.event.ctrlKey) {
        //ctrl + v
        if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
            window.event.preventDefault();
            self.basicInvoicePrint(true);
            console.log('vertical print');
        }
      }
       if (window.event.keyCode == 69 &&  window.event.ctrlKey) {
        //ctrl + e
        if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
            window.event.preventDefault();
            self.eWayBillPrint();
            console.log('eway print');
        }
      }
       if (window.event.keyCode == 71 &&  window.event.ctrlKey) {
        //ctrl + g
        window.event.preventDefault();
        self.$router.push({ path: `/settings/product-grouping/true/invoice` });
      }
       if (window.event.keyCode == 84 &&  window.event.ctrlKey) {
        //ctrl + t
        window.event.preventDefault();
         self.$router.push({ path: `/settings/product-set/true/invoice` });
      }
    }
    document.addEventListener('keydown', this._keyListener1.bind(this));
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this._keyListener1);
  },
};
</script>

<style>
.invoiceExpansion .v-expansion-panel__header {
  background-color: #15155d;
}

.invoiceExpansion .v-icon {
  color: white;
}

#printPdf { 
  position: fixed; 
  top: 0px; 
  left: 0px; 
  display: block;
  padding: 0px;
  border: 0px;
  margin: 0px;
  visibility: hidden; 
  opacity: 0; 
}
</style>



// WEBPACK FOOTER //
// src/components/Quick/Invoice/invoiceUpdate.vue